module.exports = "/images/locale_logo.svg?4a0941b06535889aea30b267e05b9ed0";